import { type Common } from '../common.js';
import { type AuditWithUser } from '../models/flow/audit.js';
import {
  type CreateSecureHeaderBody,
  type FindAllSecureHeadersParams,
  type GetAuditLogParams,
  type SecureHeader,
  type UpdateOneSecureHeaderBody,
} from '../models/flow/secureHeaders.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/secure-headers';

  constructor(common: Common) {
    this.common = common;
  }

  async create(body: CreateSecureHeaderBody): Promise<SecureHeader> {
    const url = this.common.constructPath(`${this.baseEndpoint}/`);
    return await this.common.postJSON(url, body);
  }

  async updateOneHeaderValueById(id: string, headerValue: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/secure-header-value`);
    return await this.common.patchJSON(url, { secureHeaderValue: headerValue });
  }

  async updateOneById(id: string, body: UpdateOneSecureHeaderBody): Promise<SecureHeader> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, body);
  }

  async findOneById(id: string): Promise<{ secureHeader: SecureHeader }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async findAll(params?: FindAllSecureHeadersParams): Promise<SecureHeader[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/`, params);
    return await this.common.getJSON(url);
  }

  async deleteOneById(id: string): Promise<{ deleted: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }

  async getAuditLog(
    secureHeaderId: string,
    params: GetAuditLogParams
  ): Promise<{ audits: AuditWithUser[] }> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${secureHeaderId}/audit-trail`,
      params
    );
    return await this.common.getJSON(url);
  }
}
